import "./headerStyles.scss";

const Header = () => {
  return (
    <header className="header">
      <div className="header-content">
        <h1>Scholarship Amount</h1>
        <p>
          Up to <b>$10,000</b> per year, and renewable for up to four years.
        </p>
        <p><em>Note: The scholarship amount is based on students' unmet need as
          determined by the Office of Financial Aid and Scholarships and can vary from year to year</em></p>
      </div>
    </header>
  );
};

export default Header;
